module.exports = __webpack_public_path__ + "static/media/gpvnl-logo-white.2a439947.png";